import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";

export default function Inscription() {
  const [f, setF] = useState({ prenom: "", nom: "", email: "", mot_de_passe: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async () => {
    setError("");
    if (!f.prenom || !f.nom || !f.email || f.mot_de_passe.length < 10) {
      setError("Tous les champs sont requis (mot de passe d'au moins 10 caractères)."); return;
    }
    if (f.mot_de_passe !== f.confirm) { setError("Les mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try {
      await api.post("/inscription", {
        prenom: f.prenom, nom: f.nom, email: f.email, mot_de_passe: f.mot_de_passe,
      });
      setDone(true);
    } catch (e) {
      setError(e.message || "Une erreur est survenue.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 480 }}>
      <h1>Créer un compte</h1>
      <p className="muted mb-3">
        Un compte vous permet de consulter les événements réservés et de vous inscrire
        aux manifestations. Votre demande sera validée par la mairie.
      </p>
      <div className="card">
        {done ? (
          <div className="success">
            Votre demande a bien été enregistrée. Vous recevrez un email lorsque la mairie
            aura validé votre compte. <Link to="/connexion">Retour à la connexion</Link>
          </div>
        ) : (
          <>
            {error && <div className="error">{error}</div>}
            <div className="row">
              <div className="field"><label>Prénom</label>
                <input value={f.prenom} onChange={set("prenom")} /></div>
              <div className="field"><label>Nom</label>
                <input value={f.nom} onChange={set("nom")} /></div>
            </div>
            <div className="field"><label>Email</label>
              <input type="email" value={f.email} onChange={set("email")} /></div>
            <div className="field"><label>Mot de passe (10 caractères minimum)</label>
              <input type="password" value={f.mot_de_passe} onChange={set("mot_de_passe")} /></div>
            <div className="field"><label>Confirmer le mot de passe</label>
              <input type="password" value={f.confirm} onChange={set("confirm")} /></div>
            <button onClick={submit} disabled={busy}>
              {busy ? "Envoi…" : "Créer mon compte"}
            </button>
            <p className="muted mt-2">
              Déjà un compte ? <Link to="/connexion">Se connecter</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
